// extracted by mini-css-extract-plugin
export default {"textareaWrap":"textarea_textareaWrap__P4NCm","textarea":"textarea_textarea__De7Y-","error":"textarea_error__jq5nr","textareaError":"textarea_textareaError__cJdHX"};